import StaticDataService from '../services/staticdata.service';

export const staticdata = {
    namespaced: true,
    state: {
        categories: [],
        prestataireservice: [],
        compsettings: null,
        loadingCompsettings: false,
        errorCompsettings: null,
        preststatistiques: null,
        loadingPrestStatistiques: false,
        errorPrestStatistiques: null
    },
    actions: {
        async fetchCategorie({ commit }) {
            return StaticDataService.getCategories()
                .then(
                    response => {
                        commit('fetchCategorieSuccess', response);
                        return Promise.resolve(response);
                    },
                    error => {
                        commit('fetchCategorieFailure');
                        return Promise.reject(error);
                    }
                );
        },
        async fetchPrestataireService({ commit }, data) {
            return StaticDataService.getPrestataireServices(data)
                .then(
                    response => {
                        commit('fetchPrestataireServiceSuccess', response);
                        return Promise.resolve(response);
                    },
                    error => {
                        commit('fetchPrestataireServiceFailure');
                        return Promise.reject(error);
                    }
                );
        },

        async fetchSubCategorie({ commit }, categoryId) {
            return StaticDataService.getSubCategory(categoryId)
                .then(
                    response => {
                        commit('fetchCategorieSuccess', response);
                        return Promise.resolve(response);
                    },
                    error => {
                        commit('fetchCategorieFailure');
                        return Promise.reject(error);
                    }
                );
        },

        async fetchCatAndSubCat({ commit }) {
            return StaticDataService.getCategoryAndSubCategory()
                .then(
                    response => {
                        commit('fetchCategorieSuccess', response);
                        return Promise.resolve(response);
                    },
                    error => {
                        commit('fetchCategorieFailure');
                        return Promise.reject(error);
                    }
                );
        },

        async fetchSubCategoriesByCat(_, categoryId) {
            return StaticDataService.getSubCategory(categoryId)
                .then(
                response => {
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
                );
        },

        async searchPrestataireBySubCategorie({ commit }, subCategoryId) {
            return StaticDataService.searchPrestataire(subCategoryId)
                .then(
                    response => {
                        commit('fetchCategorieSuccess', response);
                        return Promise.resolve(response);
                    },
                    error => {
                        commit('fetchCategorieFailure');
                        return Promise.reject(error);
                    }
                );
        },

        async fetchCompSetting({ commit }) {
            commit("fetchCompSettingStart");
            try {
                const response = await StaticDataService.getCompSettings();
                if (response.success) {
                    commit("fetchCompSettingSuccess", response.data);
                } else {
                    commit("fetchCompSettingFailure", response.message);
                }
            } catch (error) {
                commit("fetchCompSettingFailure", error.message);
            }
        },

        async fetchPrestStatistique({ commit }) {
            commit("fetchCompSettingStart");
            try {
                const response = await StaticDataService.getPrestStatistiques();
                if (response.success) {
                    commit("fetchPrestStatistiqueSuccess", response.data);
                } else {
                    commit("fetchPrestStatistiqueFailure", response.message);
                }
            } catch (error) {
                commit("fetchPrestStatistiqueFailure", error.message);
            }
        },

       

  

    },
    mutations: {
        fetchCategorieSuccess(state, categories) {
            state.categories = categories
        },
        fetchCategorieFailure(state) {
            state.categories = []
        },
        fetchPrestataireServiceSuccess(state, services) {
            state.prestataireservice = services
        },
        fetchPrestataireServiceFailure(state) {
            state.prestataireservice = []
        },
        fetchCompSettingStart(state) {
            state.loadingCompsettings = true;
            state.errorCompsettings = null;
        },
        fetchCompSettingSuccess(state, data) {
            state.loadingCompsettings = false;
            state.compsettings = data;
        },
        fetchCompSettingFailure(state, error) {
            state.loadingCompsettings = false;
            state.errorCompsettings = error;
            state.compsettings = null;
        },
        fetchPrestStatistiqueStart(state) {
            state.loadingPrestStatistique = true;
            state.errorPrestStatistiques = null;
        },
        fetchPrestStatistiqueSuccess(state, data) {
            state.loadingPrestStatistique = false;
            state.preststatistiques = data;
        },
        fetchPrestStatistiqueFailure(state, error) {
            state.loadingPrestStatistique = false;
            state.errorPrestStatistiques = error;
            state.preststatistiques = null;
        },
       
    }
};